import script from "./LoginMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginMobile.vue?vue&type=script&setup=true&lang=ts"

import "../../style/LoginMobile.css?vue&type=style&index=0&id=778b2542&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-778b2542"]])

export default __exports__